import { ThemeProvider as ScThemeProvider } from 'styled-components';
import { DarkTheme } from "./dark.theme";
import { jsx as _jsx } from "react/jsx-runtime";
const ThemeProvider = props => {
  const {
    children
  } = props;
  return /*#__PURE__*/_jsx(ScThemeProvider, {
    theme: DarkTheme,
    children: children
  });
};
export { ThemeProvider };